var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.654218 17.1988L1.3688 20.1369H1.9683C2.94671 17.1053 5.79167 14.9123 9.14882 14.9123C12.506 14.9123 15.3509 17.1053 16.3293 20.1369H36.9084C37.8869 17.1053 40.7318 14.9123 44.089 14.9123C47.4461 14.9123 50.2911 17.1053 51.2695 20.1369H55.6043V18.0723L54.3338 17.6753C54.3338 17.6753 55.5916 13.3632 55.6043 10.5285C55.6228 6.36937 52.9838 0.205654 52.9838 0.205654C52.9838 0.205654 43.5291 0.201937 37.6582 0.205579L37.4956 0.205678C31.7083 0.209192 24.236 0.213728 22.3325 1.07906C21.2538 2.35059 18.2033 9.65508 18.2033 9.65508C13.0947 9.99918 3.05225 10.8144 1.84525 11.3226C0.638255 11.8309 0.310118 15.3989 0.654218 17.1988ZM23.9184 2.74562L20.9009 9.25704H32.4944V2.74562H23.9184ZM35.1136 9.25654L34.8753 2.82452H50.9951L51.3127 9.25654H35.1136Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.10195,
    cy: 22.5999,
    r: 4.05,
    stroke: "#BABABA",
    strokeWidth: 2.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.102,
    cy: 22.5999,
    r: 4.05,
    stroke: "#BABABA",
    strokeWidth: 2.1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuv);
export default ForwardRef;